export enum AccentColors {
  primary = "primary",
  secondary = "secondary",
  tertiary = "tertiary",
  quaternary = "quaternary",
}

type CustomPalette = {
  primary: { main: string };
  secondary: { main: string };
  tertiary: { main: string };
  quaternary: { main: string };
  video: {
    brandColour1: string;
    brandColour2: string;
    brandColour3: string;
  };
};

const palette: CustomPalette = {
  primary: {
    main: "#008fc1",
  },
  secondary: {
    main: "#203458",
  },
  tertiary: {
    main: "#CE2029",
  },
  quaternary: {
    main: "#106936",
  },
  video: {
    brandColour1: "#1F3156",
    brandColour2: "#0090C4",
    brandColour3: "#F8A916",
  },
};

export default palette;
